// Module
var code = "<div> <div class=\"flex items-center justify-center bg-black w-12 h-12 cursor-pointer\"> <svg view=\"Icon\" data-name=\"icon-arrow-left\" class=\"text-white w-7 h-7\"></svg> <div> </div> </div></div>";
// Exports
export default code;